module.exports = __webpack_public_path__ + "static/media/more-with-round.b49397b2.svg";